export default __webpack_public_path__ + "static/media/musaDirector.6873f44d.jpg";